<template>
  <GeneralCourse />
</template>

<script>
import GeneralCourse from "../../components/GeneralCourse/GeneralCourse.vue";
export default {
  components: {
    GeneralCourse,
  },
};
</script>